import React from 'react';
import { useTranslation } from 'common/i18n/hooks';
import { useStagedExperiment } from 'iron/apps/experiments/src/components/hooks/staged-experiment';
import { InputSize } from 'common/components/input/types';
import { TagInputSearchMode } from 'common/components/tag-input/types';
import { TagInputReact } from 'common/components/tag-input';
import { useExperimentOptions } from 'iron/apps/experiments/src/components/hooks/experiment-options';
import { ExperimentPageConfigurationSetting } from '../_setting';
import styles from '../index.module.styl';
export function CollectionMethodExposureEvents(_ref: {
  isEditing: boolean;
}) {
  let {
    isEditing
  }: {
    isEditing: boolean;
  } = _ref;
  return isEditing ? <EditableExposureEvents data-sentry-element="EditableExposureEvents" data-sentry-component="CollectionMethodExposureEvents" data-sentry-source-file="exposure-events.tsx" /> : <ReadonlyExposureEvents data-sentry-element="ReadonlyExposureEvents" data-sentry-component="CollectionMethodExposureEvents" data-sentry-source-file="exposure-events.tsx" />;
}
function EditableExposureEvents() {
  var _stagedExperiment$set, _stagedExperiment$set2, _stagedExperiment$set3, _stagedExperiment$set4, _stagedExperiment$set5, _stagedExperiment$set6, _stagedExperiment$set7, _stagedExperiment$set8;
  const i18n = useTranslation();
  const {
    stagedExperiment,
    stageChanges
  } = useStagedExperiment();
  const {
    experimentNames,
    variantNames,
    defaultVariantName
  } = useExperimentOptions();
  const defaultApplied = React.useRef(true);
  if (!defaultApplied.current && stagedExperiment !== null && stagedExperiment !== void 0 && (_stagedExperiment$set = stagedExperiment.settings) !== null && _stagedExperiment$set !== void 0 && (_stagedExperiment$set = _stagedExperiment$set.exposureEventSettings) !== null && _stagedExperiment$set !== void 0 && _stagedExperiment$set.experimentName && variantNames !== null && variantNames !== void 0 && variantNames.length) {
    defaultApplied.current = true;
    stageChanges({
      settings: {
        controlKey: defaultVariantName
      }
    });
  }
  const handleEditExperimentName = (value: string) => {
    defaultApplied.current = false;
    stageChanges({
      settings: {
        exposureEventSettings: {
          experimentName: value
        },
        controlKey: ""
      }
    });
  };
  const handleEditControlKey = (value: string) => {
    stageChanges({
      settings: {
        controlKey: value
      }
    });
  };
  if (!stagedExperiment) {
    return null;
  }
  return <>
      <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.exposure-events.experiment-name")} helpText={i18n.t("experiments.configuration.exposure-events.experiment-name-info")} data-sentry-element="ExperimentPageConfigurationSetting" data-sentry-source-file="exposure-events.tsx">
        <TagInputReact className={styles.fullWidth} fieldId='experiment-name' menuSections={[{
        items: experimentNames.map(name => {
          return {
            label: name,
            value: name
          };
        })
      }]} controlledMode size={InputSize.Small} icon={stagedExperiment !== null && stagedExperiment !== void 0 && (_stagedExperiment$set2 = stagedExperiment.settings) !== null && _stagedExperiment$set2 !== void 0 && (_stagedExperiment$set2 = _stagedExperiment$set2.exposureEventSettings) !== null && _stagedExperiment$set2 !== void 0 && _stagedExperiment$set2.experimentName ? "checkmark" : "search"} searchMode={TagInputSearchMode.Combobox} mpItemsMenuAttrs={{
        'empty-message': i18n.t("experiments.configuration.no-experiment-results"),
        'empty-search-results-message': i18n.t("experiments.configuration.no-experiment-results")
      }} menuWidth={-1} searchWidth={100} value={(_stagedExperiment$set3 = stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set4 = stagedExperiment.settings) === null || _stagedExperiment$set4 === void 0 || (_stagedExperiment$set4 = _stagedExperiment$set4.exposureEventSettings) === null || _stagedExperiment$set4 === void 0 ? void 0 : _stagedExperiment$set4.experimentName) !== null && _stagedExperiment$set3 !== void 0 ? _stagedExperiment$set3 : ""} onChange={(ev: TODO) => {
        var _ev$detail$value;
        handleEditExperimentName(((_ev$detail$value = ev.detail.value) !== null && _ev$detail$value !== void 0 ? _ev$detail$value : "").trim());
      }} onClickMenuItem={(ev: TODO) => {
        handleEditExperimentName(ev.detail.value);
      }} data-sentry-element="TagInputReact" data-sentry-source-file="exposure-events.tsx" />
      </ExperimentPageConfigurationSetting>

      {Boolean(stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set5 = stagedExperiment.settings) === null || _stagedExperiment$set5 === void 0 || (_stagedExperiment$set5 = _stagedExperiment$set5.exposureEventSettings) === null || _stagedExperiment$set5 === void 0 ? void 0 : _stagedExperiment$set5.experimentName) && <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.exposure-events.control-key")} helpText={i18n.t("experiments.configuration.exposure-events.control-key-info")}>
          <TagInputReact className={styles.fullWidth} fieldId='control-key' menuSections={[{
        items: variantNames.map(name => {
          return {
            label: name,
            value: name
          };
        })
      }]} controlledMode size={InputSize.Small} icon={stagedExperiment !== null && stagedExperiment !== void 0 && (_stagedExperiment$set6 = stagedExperiment.settings) !== null && _stagedExperiment$set6 !== void 0 && _stagedExperiment$set6.controlKey ? "checkmark" : "search"} searchMode={TagInputSearchMode.Combobox} mpItemsMenuAttrs={{
        'empty-message': i18n.t("experiments.configuration.no-experiment-variant-results"),
        'empty-search-results-message': i18n.t("experiments.configuration.no-experiment-variant-results")
      }} menuWidth={-1} searchWidth={100} value={(_stagedExperiment$set7 = stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set8 = stagedExperiment.settings) === null || _stagedExperiment$set8 === void 0 ? void 0 : _stagedExperiment$set8.controlKey) !== null && _stagedExperiment$set7 !== void 0 ? _stagedExperiment$set7 : ""} onChange={(ev: TODO) => {
        var _ev$detail$value2;
        handleEditControlKey(((_ev$detail$value2 = ev.detail.value) !== null && _ev$detail$value2 !== void 0 ? _ev$detail$value2 : "").trim());
      }} onClickMenuItem={(ev: TODO) => {
        handleEditControlKey(ev.detail.value);
      }} />
        </ExperimentPageConfigurationSetting>}
    </>;
}
function ReadonlyExposureEvents() {
  var _stagedExperiment$set9, _stagedExperiment$set10, _stagedExperiment$set11, _stagedExperiment$set12, _stagedExperiment$set13;
  const i18n = useTranslation();
  const {
    stagedExperiment
  } = useStagedExperiment();
  if (!stagedExperiment) {
    return null;
  }
  return <>
      <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.exposure-events.experiment-name")} helpText={i18n.t("experiments.configuration.exposure-events.experiment-name-info")} data-sentry-element="ExperimentPageConfigurationSetting" data-sentry-source-file="exposure-events.tsx">
        {(_stagedExperiment$set9 = stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set10 = stagedExperiment.settings) === null || _stagedExperiment$set10 === void 0 || (_stagedExperiment$set10 = _stagedExperiment$set10.exposureEventSettings) === null || _stagedExperiment$set10 === void 0 ? void 0 : _stagedExperiment$set10.experimentName) !== null && _stagedExperiment$set9 !== void 0 ? _stagedExperiment$set9 : ""}
      </ExperimentPageConfigurationSetting>

      {Boolean(stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set11 = stagedExperiment.settings) === null || _stagedExperiment$set11 === void 0 || (_stagedExperiment$set11 = _stagedExperiment$set11.exposureEventSettings) === null || _stagedExperiment$set11 === void 0 ? void 0 : _stagedExperiment$set11.experimentName) && <ExperimentPageConfigurationSetting label={i18n.t("experiments.configuration.exposure-events.control-key")} helpText={i18n.t("experiments.configuration.exposure-events.control-key-info")}>
          {(_stagedExperiment$set12 = stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set13 = stagedExperiment.settings) === null || _stagedExperiment$set13 === void 0 ? void 0 : _stagedExperiment$set13.controlKey) !== null && _stagedExperiment$set12 !== void 0 ? _stagedExperiment$set12 : ""}
        </ExperimentPageConfigurationSetting>}
    </>;
}